import React from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../../components/AppIcon';

const TopPerformingJobs = ({ jobs }) => {
  const navigate = useNavigate();

  return (
    <div className="space-y-3">
      {jobs?.map((job, index) => (
        <div 
          key={job?.id}
          className="flex items-center gap-4 p-4 bg-card border border-border rounded-lg transition-smooth hover:shadow-card cursor-pointer"
          onClick={() => navigate('/candidate-management', { state: { jobId: job?.id } })}
        >
          <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10 text-primary font-semibold flex-shrink-0">
            {index + 1}
          </div>
          <div className="flex-1 min-w-0">
            <h4 className="text-sm font-semibold text-foreground mb-1 truncate">{job?.title}</h4>
            <div className="flex items-center gap-3 text-xs text-muted-foreground">
              <div className="flex items-center gap-1">
                <Icon name="Users" size={12} />
                <span>{job?.applications} applications</span>
              </div>
              <div className="flex items-center gap-1">
                <Icon name="Eye" size={12} />
                <span>{job?.views} views</span>
              </div>
            </div>
          </div>
          <div className="flex items-center gap-1 text-success flex-shrink-0">
            <Icon name="TrendingUp" size={16} />
            <span className="text-sm font-medium">{job?.conversionRate}%</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TopPerformingJobs;